export const WORKSPACE_SSO_LOGIN_PARAMS_KEY_BASE = 'workspace_sso_login_params';
export const WorkspaceSsoLoginParamsKeyFactory = {
    all: () => [WORKSPACE_SSO_LOGIN_PARAMS_KEY_BASE],
    byWorkspace: (workspaceId) => [
        ...WorkspaceSsoLoginParamsKeyFactory.all(),
        workspaceId,
    ],
};
